import React, { Component } from 'react';
import PropTypes from 'prop-types'
import { Row, Col } from 'reactstrap';
import { ThemeProvider } from '@material-ui/core/styles'
import { Box, Select, MenuItem, Typography, Grid, Container} from '@material-ui/core'
import moment from 'moment'
import { withStyles } from '@material-ui/core/styles'
import Moment from 'react-moment'
import Cancel from '@material-ui/icons/Cancel'

import SubscriberGenreComponent from './SubscriberGenreComponent'
import SubscriberReleasesComponent from './SubscriberReleasesComponent'
import SubscriberOwnershipComponent from './SubscriberOwnershipComponent'
import SubscriberRatingComponent from './SubscriberRatingComponent'
import SubscriberTabComponent from './SubscriberTabComponent'
import SubscriberOnBoarding from './SubscriberOnBoarding'
import Spinner from '../../components/Spinner'
import NotFound from '../NotFound'
import { NONE, SUBSCRIBER_NETWORK_TYPE_DEFAULT1, SUBSCRIBER_NETWORK_TYPE_DEFAULT2, SUBSCRIBER_NETWORK_TYPE_PRIMARY } from '../../constants/commons'
import { catalogYearOptions } from '../../constants/options'

import { styles } from '../../classes/Styles'
import { theme } from '../../classes/Themes'
import './SubscriberComponent.scss'
import SubscriberGenreTitleComponent from './SubscriberGenreTitleComponent'

export class SubscriberComponent extends Component {
  static propTypes = {
    isAdmin: PropTypes.bool.isRequired,
    history: PropTypes.object,
    homepage: PropTypes.object,
    subscriber: PropTypes.object,
    subscriberGenreTitle: PropTypes.object,
    subscriberCalendar: PropTypes.object,
    classes: PropTypes.object.isRequired,
    shortcut: PropTypes.shape({
      id: PropTypes.string.isRequired,
      expires_at: PropTypes.string.isRequired,
      target: PropTypes.string.isRequired,
      target_id: PropTypes.string.isRequired
    }),
    setSelectedNetwork: PropTypes.func.isRequired,
    setSelectedNetworkType: PropTypes.func.isRequired,
    selectedSubscriberNetwork: PropTypes.string,
    selectedSubscriberNetworkType: PropTypes.string,
    catalogOverviewYearChange: PropTypes.func,
    setSelectedMetricDate: PropTypes.func,
    selectedMetricDate: PropTypes.string
  }

  constructor (props) {
    super(props)

    this.state = {
      screenWidth: window.innerWidth,
      allNetworks: [],
      selectedNetworkType: null,
      selectedNetwork: null,
      selectedNetworkId: null,
      primaryNetwork: null,
      defaultNetwork1: null,
      defaultNetwork2: null,
      defaultYear: { value: '2025-01-01', label: '2025 YTD' },
      startDate: moment().subtract(1, 'months').format('YYYY-MM-DD'),
      endDate: moment().subtract(-2, 'months').format('YYYY-MM-DD'),
      selectedGenre: null,
      percentageByGenre: null,
      primaryNetworkData: [],
      defaultNetwork1Data: [],
      defaultNetwork2Data: []
    }
    this.scrollRef = React.createRef()
  }

  componentDidMount () {
    window.addEventListener('resize', this.updateDimensions)
    if (this.props.homepage && this.props.homepage.details && this.props.homepage.details.subscriber_networks.length > 0 && (this.props.subscriber && this.props.subscriber.details)) {
      this.updateDimensions()
      this.setNetworkData()
    }
    if (this.props.shortcut && this.props.subscriber && this.props.subscriber.details) {
      this.updateDimensions()
      this.setNetworkData()
    }
  }

  componentDidUpdate (prevProps, prevState) {
    if (this.props.homepage && this.props.homepage.details && this.props.homepage.details.subscriber_networks.length > 0 && (prevProps.subscriber && prevProps.subscriber.details) !== (this.props.subscriber && this.props.subscriber.details) && (this.props.subscriber && this.props.subscriber.details)) {
      this.updateDimensions()
      this.setNetworkData()
    }
    if (this.props.shortcut && (prevProps.subscriber && prevProps.subscriber.details) !== (this.props.subscriber && this.props.subscriber.details) && this.props.subscriber && this.props.subscriber.details) {
      this.updateDimensions()
      this.setNetworkData()
    }
    if (prevState.selectedNetwork !== this.state.selectedNetwork && this.state.selectedNetwork) {
      this.props.setSelectedNetwork(this.state.selectedNetwork)
      this.props.setSelectedNetworkType(this.state.selectedNetworkType)
      this.setSelectedGenre(null)
    }
    if (this.state.selectedNetworkType === SUBSCRIBER_NETWORK_TYPE_PRIMARY && this.props.subscriber.details &&
      (prevState.primaryNetwork !== this.state.primaryNetwork && this.state.primaryNetwork)) {
        if (null !== prevProps.selectedSubscriberNetwork && prevProps.selectedSubscriberNetwork !== this.state.primaryNetwork.network) {
          this.setSelectedNetwork(SUBSCRIBER_NETWORK_TYPE_PRIMARY, this.state.primaryNetwork.network, this.state.primaryNetwork.network_entity_id)
        }
    }
    if (this.state.selectedNetworkType === SUBSCRIBER_NETWORK_TYPE_DEFAULT1 && this.props.subscriber.details &&
      (prevState.defaultNetwork1 !== this.state.defaultNetwork1 && this.state.defaultNetwork1)) {
        if (null !== prevProps.selectedSubscriberNetwork && prevProps.selectedSubscriberNetwork !== this.state.defaultNetwork1.network) {
          this.setSelectedNetwork(SUBSCRIBER_NETWORK_TYPE_DEFAULT1, this.state.defaultNetwork1.network, this.state.defaultNetwork1.network_entity_id)
        }
    }
    if (this.state.selectedNetworkType === SUBSCRIBER_NETWORK_TYPE_DEFAULT2 && this.props.subscriber.details &&
      (prevState.defaultNetwork2 !== this.state.defaultNetwork2 && this.state.defaultNetwork2)) {
        if (null !== prevProps.selectedSubscriberNetwork && prevProps.selectedSubscriberNetwork !== this.state.defaultNetwork2.network) {
          this.setSelectedNetwork(SUBSCRIBER_NETWORK_TYPE_DEFAULT2, this.state.defaultNetwork2.network, this.state.defaultNetwork2.network_entity_id)
        }
    }
  }

  updateDimensions = () => {
    this.setState({ screenWidth: window.innerWidth })
  }

  setNetworkData = () => {
    let allNetwork = []
    const networks = this.props.subscriber.details.subscriber_networks
    const primary = networks.filter(n => n.is_primary)
    const defaults = networks.filter(n => n.is_default)
    const nonDefaults = networks.filter(n => !n.is_primary && !n.is_default)
    primary.map(n => allNetwork.push(n))
    defaults.map(n => allNetwork.push(n))
    nonDefaults.map(n => allNetwork.push(n))
    allNetwork.push( { network: NONE })

    this.setState({
      allNetworks: allNetwork,
      primaryNetwork: primary[0],
      defaultNetwork1: defaults[0],
      defaultNetwork2: defaults[1],
      selectedNetwork: primary[0].network,
      selectedNetworkId: primary[0].network_entity_id,
      selectedNetworkType: SUBSCRIBER_NETWORK_TYPE_PRIMARY
    })
  }

  setSelectedNetwork = (networkType, network, networkId) => {
    this.setState({
      selectedNetworkType: networkType,
      selectedNetwork: network,
      selectedNetworkId: networkId
    })
  }

  handleNetworkChange = (event, index) => {
    if (index === 1) {
      this.setState({ primaryNetwork: this.state.allNetworks.filter(n => n.network === event.target.value)[0]})
    } else if (index === 2) {
      this.setState({ defaultNetwork1: this.state.allNetworks.filter(n => n.network === event.target.value)[0]})
    } else if (index === 3) {
      this.setState({ defaultNetwork2: this.state.allNetworks.filter(n => n.network === event.target.value)[0]})
    }
  }

  setSelectedGenre = (genre) => {
    this.setState({ selectedGenre: genre})
  }

  setPercentageByGenre = (genres, primaryNetworkData, defaultNetwork1Data, defaultNetwork2Data) => {
    this.setState({
      percentageByGenre: genres,
      primaryNetworkData: primaryNetworkData,
      defaultNetwork1Data: defaultNetwork1Data,
      defaultNetwork2Data: defaultNetwork2Data
    })
  }

  handleYearChanges = (e) => {
    this.setState({ defaultYear: { value: e.target.value, label: '' } })
    this.props.setSelectedMetricDate(e.target.value)
    this.props.catalogOverviewYearChange(e.target.value)
  }

  _renderShortcut () {
    if (!this.props.shortcut || this.state.hideShortcutBanner) {
      return null
    }

    const expires = this.props.shortcut.expires_at
    const click = e => {
      e.preventDefault()
      this.setState({ hideShortcutBanner: true })
    }

    return (
      <div className='shortCutBanner'>
        <span>
          <span>This preview of content analytics of Catalog Overview will expire on&nbsp;</span>
          <Moment format='MM/DD/YYYY'>{expires}</Moment>
        </span>
        <span onClick={click}><Cancel /></span>
      </div>
    )
  }

  _renderOnboarding () {
    if (!this.props.shortcut) {
      return null
    }
    return (
      <SubscriberOnBoarding
        run={true}
        setScroll={this._setScroll.bind(this)}
        />
    )
  }

  _setScroll () {
    window.scrollTo({
      top: this.scrollRef.current.offsetTop + 200
    })
  }

  render () {
    if ((this.props.homepage && this.props.homepage.isFetching) || (this.props.subscriber && this.props.subscriber.isFetching)) {
      return (<Spinner />)
    }

    if (this.props.subscriber && (this.props.subscriber.error || (!this.props.subscriber.isFetching && this.props.subscriber.details && this.props.subscriber.details.subscriber_networks && this.props.subscriber.details.subscriber_networks.length === 0))) {
      return (<NotFound isAdmin={this.props.isAdmin}/>)
    }

    const { classes, subscriber, subscriberGenreTitle } = this.props
    const primaryNetwork = this.state.primaryNetwork ? this.state.primaryNetwork.network : ''
    const defaultNetwork1 = this.state.defaultNetwork1 ? this.state.defaultNetwork1.network : ''
    const defaultNetwork2 = this.state.defaultNetwork2 ? this.state.defaultNetwork2.network : ''
    const lg = (this.state.screenWidth >= 1024 && this.state.screenWidth < 1085) ? 12 : 6
      return (
        <ThemeProvider theme={theme}>
          <Box className="rightSide subscriberComponent" ref={this.scrollRef}>
            <Container maxWidth="xl" className={classes.containerRootSubscriber}>
              {this._renderShortcut()}
              {this._renderOnboarding ()}
              <Row className="header subscriberHeader">
                <Col>
                  <ul className="hFirstRow">
                    <li className="imgHolder">
                      <img alt="" src="/static/images/catalogOverview.svg" className="imgThumb" />
                    </li>
                    <li>
                      <h2 className="title">Catalog Overview</h2>
                    </li>
                  </ul>
                </Col>
              </Row>
              <div id='subscriberTour2'>
                <Row>
                  <Col>
                    <Box className="productSelect" id='subscriberTour1'>
                      <Box>
                        <Select
                          labelId="select-filled-label"
                          id="select-filled"
                          className='metricsSelect metricsLegend1'
                          value={primaryNetwork}
                          onChange={(e) => this.handleNetworkChange(e, 1)}
                      >
                          { this.state.allNetworks.length > 0 && this.state.allNetworks.map(network => {
                          if (network.network !== NONE) {
                            return (
                              <MenuItem value={network.network} key={network.network} className='trackerSelect'>
                                <span className='subLegend menuLegend1'></span>
                                <Box className="d-flex flex-column pt-1">
                                  <span className="optionLabel">{network.network}</span>
                                </Box>
                              </MenuItem>
                            )
                          }
                        })
                        }
                        </Select>
                        <Select
                          labelId="select-filled-label"
                          id="select-filled"
                          className='metricsSelect metricsLegend2'
                          value={defaultNetwork1}
                          onChange={(e) => this.handleNetworkChange(e, 2)}
                      >
                          { this.state.allNetworks.length > 0 && this.state.allNetworks.map(network => {
                            return (
                              <MenuItem value={network.network} key={network.network}>
                                <span className='subLegend menuLegend2'></span>
                                <Box className="d-flex flex-column pt-1">
                                  <span className="optionLabel">{network.network}</span>
                                </Box>
                              </MenuItem>
                            )
                          })
                          }
                        </Select>
                        <Select
                          labelId="select-filled-label"
                          id="select-filled"
                          className='metricsSelect metricsLegend3'
                          value={defaultNetwork2}
                          onChange={(e) => this.handleNetworkChange(e, 3)}
                      >
                          { this.state.allNetworks.length > 0 && this.state.allNetworks.map(network => {
                            return (
                              <MenuItem value={network.network} key={network.network}>
                                <span className='subLegend menuLegend3'></span>
                                <Box className="d-flex flex-column pt-1">
                                  <span className="optionLabel">{network.network}</span>
                                </Box>
                              </MenuItem>
                            )
                          })
                          }
                        </Select>
                      </Box>
                      <Box>
                        {/* <Typography variant="body1" className="metricsSelect1">2021 (Full year)</Typography> */}
                        <Select
                          labelId="select-filled-label"
                          id="select-filled"
                          className='metricsSelect1'
                          value={this.state.defaultYear.value}
                          onChange={(e) => this.handleYearChanges(e)}
                      >
                          { catalogYearOptions.length > 0 && catalogYearOptions.map(year => {
                            return (
                              <MenuItem value={year.value} key={year.label}>
                                <Box className="d-flex flex-column pt-1">
                                  <span className="optionLabel">{year.label}</span>
                                </Box>
                              </MenuItem>
                            )
                          })
                          }
                        </Select>
                      </Box>
                    </Box>
                    <Box className="matchingMetrics d-flex justify-content-between">
                      <Typography variant="h5" className="sectionTitle">Matching Metrics</Typography>
                    </Box>
                  </Col>
                </Row>
                <Row className="rowSpacing metricSection">
                  <Col>
                    <Grid container spacing={2}>
                      <Grid item xs={12} lg={4} md={6} sm={12} className='modulePadding'>
                        <SubscriberReleasesComponent
                          primaryNetwork={this.state.primaryNetwork}
                          defaultNetwork1={this.state.defaultNetwork1}
                          defaultNetwork2={this.state.defaultNetwork2}
                          subscriber={subscriber}
                        />
                      </Grid>
                      <Grid item xs={12} lg={4} md={6} sm={12} className='modulePadding'>
                        <SubscriberOwnershipComponent
                          primaryNetwork={this.state.primaryNetwork}
                          defaultNetwork1={this.state.defaultNetwork1}
                          defaultNetwork2={this.state.defaultNetwork2}
                          subscriber={subscriber}
                        />
                      </Grid>
                      <Grid item xs={12} lg={4} md={6} sm={12} className='modulePadding'>
                        <SubscriberRatingComponent
                          primaryNetwork={this.state.primaryNetwork}
                          defaultNetwork1={this.state.defaultNetwork1}
                          defaultNetwork2={this.state.defaultNetwork2}
                          subscriber={subscriber}
                        />
                      </Grid>
                    </Grid>
                  </Col>
                </Row>
              </div>
              <Row className="rowSpacing">
                <Col>
                  <hr className="SecDivide"/>
                </Col>
              </Row>
              <div id='subscriberTour3'>
                <Row className="rowSpacing">
                  <Col>
                    <SubscriberTabComponent
                      primaryNetwork={this.state.primaryNetwork}
                      defaultNetwork1={this.state.defaultNetwork1}
                      defaultNetwork2={this.state.defaultNetwork2}
                      subscriber={subscriber}
                      setSelectedNetwork={this.setSelectedNetwork}
                    />
                  </Col>
                </Row>
                <Row className="rowSpacing">
                  <Col>
                    <Grid container spacing={2} id='teasersAndWhatsNew'>
                      <Grid item xs={12} lg={lg} md={12} sm={12} className='modulePadding'>
                        <SubscriberGenreComponent
                          primaryNetwork={this.state.primaryNetwork}
                          defaultNetwork1={this.state.defaultNetwork1}
                          defaultNetwork2={this.state.defaultNetwork2}
                          subscriber={subscriber}
                          selectedNetwork={this.state.selectedNetwork}
                          selectedNetworkType={this.state.selectedNetworkType}
                          selectedGenre={this.state.selectedGenre}
                          setSelectedGenre={this.setSelectedGenre}
                          setPercentageByGenre={this.setPercentageByGenre}
                        />
                      </Grid>
                      <Grid item xs={12} lg={lg} md={12} sm={12} className='modulePadding'>
                        <SubscriberGenreTitleComponent
                          primaryNetwork={this.state.primaryNetwork}
                          defaultNetwork1={this.state.defaultNetwork1}
                          defaultNetwork2={this.state.defaultNetwork2}
                          subscriber={subscriber}
                          subscriberGenreTitle={subscriberGenreTitle}
                          selectedNetwork={this.state.selectedNetwork}
                          selectedNetworkId={this.state.selectedNetworkId}
                          selectedGenre={this.state.selectedGenre}
                          selectedNetworkType={this.state.selectedNetworkType}
                          percentageByGenre={this.state.percentageByGenre}
                          primaryNetworkData={this.state.primaryNetworkData}
                          defaultNetwork1Data={this.state.defaultNetwork1Data}
                          defaultNetwork2Data={this.state.defaultNetwork2Data}
                        />
                      </Grid>
                    </Grid>
                  </Col>
                </Row>
              </div>
            </Container>
          </Box>
        </ThemeProvider>
      )
  }
}

export default withStyles(styles)(SubscriberComponent)
